import axios from 'axios';
import React from 'react';

interface State {
  selectedCompanyId?: number;
  setSelectedCompanyId: (companyId?: number) => void;
}

const GuarantorsContext = React.createContext({
  setSelectedCompanyId: (companyId?: number): void => {
  }
});

interface Props extends JSX.ElementChildrenAttribute {
}

export class GuarantorsProvider extends React.Component<Props, State> {

  cancelTokenSource = axios.CancelToken.source();

  constructor(props: any) {
    super(props);

    this.state = {
      setSelectedCompanyId: this.setSelectedCompanyId
    };
  }

  componentWillUnmount(): void {
    this.cancelTokenSource.cancel('Component unmounted.');
  }

  setSelectedCompanyId = (companyId?: number) => {
    this.setState({
      selectedCompanyId: companyId
    });
  }

  render() {
    return (
        <GuarantorsContext.Provider value={this.state}>
          {this.props.children}
        </GuarantorsContext.Provider>
    )
  }
}

export const GuarantorsConsumer = GuarantorsContext.Consumer;

export interface GuarantorsConsumerRenderProps extends State {
}

export const withGuarantorsContext = (Component: typeof React.Component | React.FunctionComponent<any>) => {
  return (props: any) => (
      <GuarantorsConsumer>
        {({...patientEntryProps}: GuarantorsConsumerRenderProps) => {
          return <Component {...props} {...patientEntryProps} />
        }}
      </GuarantorsConsumer>
  );
};
